import { CoupaGetFuelRatesRequest } from '@trukt/tms-api/CoupaService';
import { createKey } from './createKey';

const keyHandler = createKey('coupa');

export const CoupaServiceKeys = {
  key: keyHandler.key,
  getFuelRates: keyHandler.createMethod<CoupaGetFuelRatesRequest>(),
};
